import React from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';

class Tabs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedTabIndex: 0
        };
    }

    onSelectedTabChange(tabIndex) {
        const tabClicked = this.props.children[tabIndex];
        if (this.state.selectedTabIndex !== tabIndex) {
            this.setState({ selectedTabIndex: tabIndex });
        }

        if (this.props.onTabClick && tabClicked.props.category) {
            this.props.onTabClick(tabClicked.props.category);
        }
    }

    render () {
        const children = React.Children.toArray(this.props.children);
        return (
            <section className="tab container">
                <nav>
                    <h4>Filter by</h4>
                    <ol>
                        {
                            children.map((child, index) => {
                                const listItemClass = ClassNames({ active: index === this.state.selectedTabIndex })
                                return (
                                    <li className={ listItemClass } key={ child.props.title }>
                                        <button type="button" onClick={ this.onSelectedTabChange.bind(this, index) }>{ child.props.title }</button>
                                    </li>
                                )
                            })
                        }
                    </ol>
                </nav>
                { children[this.state.selectedTabIndex] }
            </section>
        );
    }

    static propTypes = {
        onTabClick: PropTypes.func // onTabClick(tabName : string)
    }
}

export default Tabs;
